import { Component, EventEmitter, Input, Output, SimpleChanges, OnChanges } from '@angular/core';
import { HelperServiceService } from '../../../../../utils/helper-service.service';
import { CommonModule } from '@angular/common';
import { CdkDragHandle } from '@angular/cdk/drag-drop';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { environment } from '../../../../../../environments/environment';
import { CourseService } from '../../../../../pages/courses/course.service';
import { ToasterService } from '../../../../../providers/toaster/toaster.service';
import { ConfomerService } from '../../../../../providers/confomer/confomer.service';
import { Store } from '@ngrx/store';
import { selectCourseId } from '../../../../../pages/courses/create-courses/store/course.selector';
import { take } from 'rxjs';
import { CourseHelperServiceService } from '../../../../../pages/courses/course-helper-service.service';

@Component({
  selector: 'app-certificate-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, CdkDragHandle],
  templateUrl: './certificate-form.component.html',
  styleUrl: './certificate-form.component.css'
})
export class CertificateFormComponent implements OnChanges {
  @Input() data: any
  @Input() index: any
  @Input() coursePublished: boolean = false

  courseId: any
  subjectId: any

  certificateData: any
  certificateForm!: FormGroup
  isPreview: boolean = true
  flag: number = 0

  isSubmitting = false;

  constructor(private helperService: HelperServiceService, private fb: FormBuilder,
    private courseApiService: CourseService, private toasterService: ToasterService,
    private conformDialog: ConfomerService, private store: Store, private couserHelper: CourseHelperServiceService
  ) {
    this.certificateForm = this.fb.group({
      id: [0],
      course_id: [0, Validators.required],
      structure_id: [0, Validators.required],
      certificate_id: ['', Validators.required],
      activities_to_be_considered: [''],
    });
  }

  ngOnInit(): void {
    this.store.select(selectCourseId).pipe(take(1)).subscribe(value => {
      this.courseId = value
    })
    this.initializeComponentData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && changes['data'].currentValue) {
      this.initializeComponentData();
    }
  }

  private initializeComponentData() {
    this.isPreview = this.data?.certificate?.isEditing ? false : true || false
    this.subjectId = this.data?.structure_id
    this.flag = this.data?.certificate?.flag ?? 0
    this.certificateData = this.data?.certificate
    this.patchValues(this.certificateData)
  }

  patchValues(data: any) {
    this.certificateForm.patchValue({
      id: data.id ?? 0,
      course_id: this.courseId ?? 0,
      structure_id: this.subjectId ?? 0,
      certificate_id: data.certificate_id ?? '',
      activities_to_be_considered: data.activities_to_be_considered ?? '',
    });
  }

  addCertificateStructure() {
    if (this.isSubmitting) return;
    if (this.certificateForm.invalid) {
      this.certificateForm.markAllAsTouched();
      this.toasterService.setToaster('error', 'Invalid Form', 'Please fill all required fields correctly.');
      return;
    }

    this.isSubmitting = true;
    const formData = this.createFormData(this.certificateForm.value);
    
    this.courseApiService.addCertificateNode(formData).subscribe((res: any) => {
      try {
        if (res.body.status == "success") {
          this.toasterService.setToaster('success', 'Certificate Added', res.body.message);
          this.isPreview = true;
          this.patchValues(this.certificateForm.value);
          this.emitData('get_data');
        }
      } catch (error) {
        this.toasterService.setToaster('error', 'Certificate failed to add', res?.body?.message);
      } finally {
        this.isSubmitting = false;
      }
    }, () => {
      this.isSubmitting = false;
    })
  }

  UpdateCertificateStructure() {
    if (this.isSubmitting) return;
    
    if (this.certificateForm.invalid) {
      this.certificateForm.markAllAsTouched();
      this.toasterService.setToaster('error', 'Invalid Form', 'Please fill all required fields correctly.');
      return;
    }

    this.isSubmitting = true;
    const formData = this.createFormData(this.certificateForm.value);
    formData.delete('id');
    let id = this.certificateForm.value.id
    this.courseApiService.updateCertificateNode(formData, id).subscribe((res: any) => {
      try {
        if (res.body.status == "success") {
          this.toasterService.setToaster('success', 'Certificate Updated', res.body.message);
          this.isPreview = true;
          this.patchValues(this.certificateForm.value);
          this.emitData('get_data');
        }
      } catch (error) {
        this.toasterService.setToaster('error', 'Certificate failed to update', res?.body?.message);
      } finally {
        this.isSubmitting = false;
      }
    }, () => {
      this.isSubmitting = false;
    })
  }

  async deleteCertificateStructure(id: any) {
    let confirm = await this.conformDialog.Open('Delete Certificate', 'Are you sure you want to delete this certificate?');
    if (confirm) {
      this.courseApiService.deleteCertificateNode(id).subscribe((res: any) => {
        try {
          if (res.body.status == "success") {
            this.toasterService.setToaster('success', 'Certificate Deleted', res.body.message);
            this.emitData('get_data');
          }
        } catch (error) {
          this.toasterService.setToaster('error', 'Certificate failed to delete', res.body.message);
        }
      })
    }
  }

  deleteCertificateStructureNew() {
    this.emitData('delete_certificate_structure', this.index);
  }

  createFormData(data: any): FormData {
    const formData = new FormData();

    formData.append('course_id', data.course_id);
    formData.append('structure_id', data.structure_id);
    formData.append('certificate_id', data.certificate_id);
    formData.append('activities_to_be_considered', data.activities_to_be_considered);
    formData.append('is_active', '1');

    return formData;
  }

  closePreview() {
    this.isPreview = true
    this.patchValues(this.certificateData)
  }

  @Output() dataEvent = new EventEmitter<any>();

  emitData(action: string, index?: any) {
    let data = {
      action: action,
      index: index ?? null,
    }
    this.dataEvent.emit(data);
  }
}